<template>
  <div class="desc-cont">
    <div
      class="button"
      @click="isShow1 = !isShow1"
    >페이지를 만든 이유</div>
    <div class="content" v-if="isShow1">
얼마전 중소  기업 취업자, 소득세 감면 신청서를 작성했다.<br>
그러던 중 취업 시 연령을 입력하는 곳에서 멘붕에 빠졌다.<br>
27년 5월 13일. 이런 식으로 연령을 기억하는 사람이 어딨어…<br>
다행히 날짜를 계산해주는 엑셀이 있어 그것을 이용 하기 위해 다운 받았다.<br>
근데… 나에겐 엑셀이 없었다.. 현재 mac을 사용하고 있어 엑셀이 설치되어있지 않았다.<br>
좌절….. 그냥 하지 말까? 라는 생각도 들었지만..<br>
소급적용시 최대 150만원까지 돌려 받을 수 있다고 해서 다시 시도해 보았다.<br>
그러면서 든 생각이 날짜 계산을 브라우져에서 해주는 사이트가 있다면 참 편리하겠다 싶었다.<br>
파일을 다운 받을 필요도 없고, 엑셀을 설치 할 필요도 없으니까.<br>
그래서 날짜를 계산해주는 사이트를 만들게 되었다.<br>
무쪼록 사람들이 잘 이용해 주었으면 한다.<br>
    </div>
    <div
      class="button"
      @click="isShow2 = !isShow2"
    >페이지 이용 방법</div>
    <div class="content" v-if="isShow2">
기본적으로 웹 페이지 이기때문에 브라우저를 통해 접속하면 누구나 이용 가능합니다.<br>
현재 제작자는 크롬 브라우저를 이용하여 개발 하였으므로 크롬에서 확실히 돌아간다고 보증합니다.<br>
다른 몇몇 브라우저들(파이어폭스, 사파리)도 작동 할 것같습니다.<br>
다만 ie에서의 동작이 걱정스럽습니다. mac에서 개발을 하였기에 ie에서 실행해보지 못했습니다.<br>
ie에서 이용하다 이상이 있으시면 번거우시더라도 chrome을 이용해주시면 감사하겠습니다.<br>
    </div>
    <div
      class="button"
      @click="isShow3 = !isShow3"
    >소득세 감면 신청 방법</div>
    <div class="content" v-if="isShow3">
일반적으로 이 페이지에 접속한 사람은 날짜 계산을 위해 들어오신 분이라고 생각합니다.<br>
만약 소득세 감면 신청이 궁금하여 오신 분이라면 구글에 '중소기업 취업자, 소득세 감면'을 검색하시면 됩니다.<br>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        isShow1: false,
        isShow2: false,
        isShow3: false
      }
    },
    methods: {
    },
  }
</script>

<style lang="scss" scoped>
.desc-cont {
  margin-top: 20px;
  .button {
    cursor: pointer;
    margin: 8px 0px;
    color: dodgerblue;
    font-size: 14px;
  }
  .content {
    padding: 0px 4px;
    text-align: left;
    font-size: 16px;
    white-space: pre-wrap;
    line-height: 1.4;
  }
}
</style>
